import { Tab } from './Models';
import { Type, ViewChild } from '@angular/core';
import * as _ from 'node_modules/underscore';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { recaudoUI } from './RecaudoUI';

/**
 * Provee funciones que permiten administrar pestañas
 */
export class TabsManager {
  //lista de pestañas
  private tabs: Array<Tab> = [];
  //se inicializa para poder hacer uso de sus mienbros
  public tabActual: Tab = new Tab(null, null, null);

  //Maneja la tap que debe mostrarse despues de que una tap se haya eliminado
  @ViewChild('tabConfig') tabConfig: NgbTabset;

  //Clave en sessionStorage para persistir la pestaña activa entre recargas
  private static readonly STORAGE_KEY = "recaudo:ultimaTab";

  /**
   * Agrega una nueva pestaña.
   * @param header Texto que se muestra en el header de la pestaña.
   * @param icon Icono que se muestra en la pestaña.
   * @param component Nombre del componente que se mostrará en el contenido de la tab.
   * @param componentData Objecto que define los parámetros que se le injectarán al componente.
   * @param permitirMultiplicar Indica pueden haber otras pestañas con instancias del componente que se referencia en la actual
   * @param permitirCerrar Indica si la pestaña se puede cerrar
   */
  agregar(header: string, icon: string, component: Type<any>, componentData: object = {}, permitirMultiplicar: boolean = true, permitirCerrar: boolean = true) {
    let tabMismoComponente = _.findWhere(this.tabs, { component: component });


    let tabsAbiertas = this.getTabs();
    let existeTab = _.find(tabsAbiertas, (tab) => { return tab.header == header; });

    //Si la tab que se está abriendo existe y su cabecera igual, entonces coloca visible la tab que está abierta
    if (existeTab)
      this.setTabConfigChangeTab(existeTab["guid"]);

    //Si no esta abierta, crea una nueva tab
    else {

      //si hay una tab que impide multiples instancias de un mismo componente en las pestañas.
      if (tabMismoComponente && !tabMismoComponente.permitirMultiplicar) {
        //Object.assign(this.tabActual, tabMismoComponente);
        return;
      }

      let tab = new Tab(header, icon, component, componentData, permitirMultiplicar, permitirCerrar);
      //Infiere la clave de restauración a partir de la forma del componentData (p.ej. idMatricula + anio)
      const r = TabsManager.inferirRestore(header, icon, componentData);
      if (r) {
        tab.restoreKey = r.key;
        tab.restoreData = r.data;
      }
      this.tabs.push(tab);

      //actualiza la tab actual
      this.tabActual.clonar(tab);
      this.persistirTabActual();
    }
  }

  /**
   * Agrega un objeto de tipo Tab a las pestañas.
   * @param tab
   */
  agregarTab(tab: Tab) {
    this.agregar(tab.header, tab.icon, tab.component, tab.componentData, tab.permitirMultiplicar, tab.permitirCerrar);
  }

  /**
   * 
   * @param tab 
   * @param component 
   */
  setTab(guid, component, tab?) {
    let i = _.findIndex(this.tabs, { guid: guid });

    if (i != -1) {
      if (component)
        this.tabs[i].currentComponent = component;

      //Sobreescribe las propiedades de la tab
      if (tab) {
        this.tabs[i].header = tab["header"];
        this.tabs[i].icon = tab["icon"];
      }
    }
  }

  /**
   * Cierra todas las tabs excepto la tab principal
   */
  cerrarTodasLasTabs() {
    for (var i = 0; i < this.tabs.length; i++) {

      if (this.tabs[i].header != "Principal") {
        let _i = _.findIndex(this.tabs, { guid: this.tabs[i].guid });

        if (_i != -1) {
          this.tabs.splice(_i, 1);
          i--;
        }
      }

    }
    this.limpiarUltimaTabPersistida();
  }

  /**
   * Elimina una pestaña de la lista
   * @param guid
   */
  eliminar(guid: string) {
    let i = _.findIndex(this.tabs, { guid: guid });
    let tabEliminada: Tab = null;

    if (i != -1) {
      tabEliminada = this.tabs[i];
      this.tabs.splice(i, 1);
    }

    //Si cerramos la pestaña restaurable, limpia la persistencia para no reabrirla al recargar
    if (tabEliminada && tabEliminada.restoreKey) {
      const persistido = this.getUltimaTabPersistida();
      if (persistido && persistido.key === tabEliminada.restoreKey
          && JSON.stringify(persistido.data) === JSON.stringify(tabEliminada.restoreData)) {
        this.limpiarUltimaTabPersistida();
      }
    }

    this.persistirTabActual();
  }

  /**
   * Actualiza el modelo de tab
   */
  setTabConfig(tabConfig) {
    this.tabConfig = tabConfig;

  }

  /**
   * Cambia de  tab visible
   * @param index 
   */
  setTabConfigChangeTab(index) {
    this.tabConfig.select(index);
  }

  /**
   * Obtiene la configuracion de las tabs html
   */
  getTabConfig() {
    return this.tabConfig;
  }

  getTabs() {
    return this.tabs;
  }

  /**
   * Edita la teb actual a la que el usuario está viendo
   * @param tab
   */
  setTabActual(tab: Tab){
    this.tabActual.clonar(tab);
    this.persistirTabActual();
  }

  /**
   * Obtiene el tab actual
   */
  getTabActual() {
    return this.tabActual;
  }

  /**
   * Guarda en sessionStorage la ficha restaurable de la pestaña actualmente activa, para
   * poder reabrirla al recargar la app. Si la pestaña activa NO es restaurable (ej. "Principal"
   * o alguna pantalla sin identificador fuerte), deja la última entrada buena intacta — así
   * una recarga tras volver al Principal todavía puede reabrir la ficha que se estaba viendo.
   * La limpieza explícita se hace sólo al cerrar la pestaña restaurable (ver eliminar) o al
   * cerrar todas las pestañas / cambiar de colegio.
   */
  private persistirTabActual() {
    try {
      //La tab activa real está en el arreglo; tabActual puede traer una copia desactualizada
      const t: Tab = _.findWhere(this.tabs, { guid: this.tabActual && this.tabActual.guid }) || null;
      if (t && t.restoreKey) {
        const payload = { key: t.restoreKey, header: t.header, icon: t.icon, data: t.restoreData };
        sessionStorage.setItem(TabsManager.STORAGE_KEY, JSON.stringify(payload));
      }
      //No tocar la entrada cuando la pestaña activa no es restaurable
    } catch (e) { /* sessionStorage no disponible */ }
  }

  /**
   * Devuelve el payload persistido de la última ficha abierta (o null si no hay).
   */
  getUltimaTabPersistida(): { key: string, header: string, icon: string, data: any } | null {
    try {
      const s = sessionStorage.getItem(TabsManager.STORAGE_KEY);
      return s ? JSON.parse(s) : null;
    } catch (e) {
      return null;
    }
  }

  limpiarUltimaTabPersistida() {
    try { sessionStorage.removeItem(TabsManager.STORAGE_KEY); } catch (e) {}
  }

  /**
   * Deduce una clave de restauración a partir de la forma del componentData entregado al abrir
   * una pestaña. Si el shape no coincide con ninguno conocido, devuelve null y la pestaña no se
   * persiste (se abrirá de nuevo en el flujo normal del usuario). Esto evita tener que modificar
   * los ~15 sitios que llaman a agregar().
   */
  private static inferirRestore(header: string, icon: string, componentData: any): { key: string, data: any } | null {
    if (!componentData) return null;

    //Matrícula: { idMatricula, anio }
    if (componentData.idMatricula != null && componentData.anio && componentData.anio.Id != null) {
      return { key: "matricula", data: { idMatricula: componentData.idMatricula, idAnio: componentData.anio.Id } };
    }

    //Recibo: { idRecibo, anio }
    if (componentData.idRecibo != null && componentData.anio && componentData.anio.Id != null) {
      return { key: "recibo", data: { idRecibo: componentData.idRecibo, idAnio: componentData.anio.Id } };
    }

    //Cobro: { idCobro, anio }
    if (componentData.idCobro != null && componentData.anio && componentData.anio.Id != null) {
      return { key: "cobro", data: { idCobro: componentData.idCobro, idAnio: componentData.anio.Id } };
    }

    return null;
  }
}
